// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yStR","footer":"styles_footer__2ZF33"};